// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__ym5s0","colMin":"styles_colMin__3s8hA","colCheckbox":"styles_colCheckbox__lzpH-"};